var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("VForm", {
    staticClass: "manager-create-form",
    attrs: { "on-submit-async": _vm.submit },
    on: {
      success: function(value) {
        return this$1.$emit("success", value)
      }
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function(ref) {
          var form = ref.form
          return [
            _c("UserCreateAndUpdateFormItems", {
              attrs: {
                form: form,
                data: _vm.manager,
                "is-create-form": false,
                "enable-change-password": true
              }
            }),
            _c("PeopleCreateAndUpdateFormItems", {
              attrs: { form: form, data: _vm.manager, "action-type": "update" }
            }),
            _c("ManagerCreateAndUpdateFormItems", {
              attrs: { form: form, data: _vm.manager }
            })
          ]
        }
      }
    ])
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }